function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "74bztgnbva",
  d: "M18.453 18.875h-.703V2.844c0-.466-.378-.844-.844-.844H5.094c-.466 0-.844.378-.844.844v16.031h-.703c-.233 0-.422.189-.422.422V20h15.75v-.703c0-.233-.189-.422-.422-.422zM7.625 4.672c0-.233.189-.422.422-.422h1.406c.233 0 .422.189.422.422v1.406c0 .233-.189.422-.422.422H8.047c-.233 0-.422-.189-.422-.422V4.672zm0 3.375c0-.233.189-.422.422-.422h1.406c.233 0 .422.189.422.422v1.406c0 .233-.189.422-.422.422H8.047c-.233 0-.422-.189-.422-.422V8.047zm1.828 5.203H8.047c-.233 0-.422-.189-.422-.422v-1.406c0-.233.189-.422.422-.422h1.406c.233 0 .422.189.422.422v1.406c0 .233-.189.422-.422.422zm2.672 5.625h-2.25v-2.953c0-.233.189-.422.422-.422h1.406c.233 0 .422.189.422.422v2.953zm2.25-6.047c0 .233-.189.422-.422.422h-1.406c-.233 0-.422-.189-.422-.422v-1.406c0-.233.189-.422.422-.422h1.406c.233 0 .422.189.422.422v1.406zm0-3.375c0 .233-.189.422-.422.422h-1.406c-.233 0-.422-.189-.422-.422V8.047c0-.233.189-.422.422-.422h1.406c.233 0 .422.189.422.422v1.406zm0-3.375c0 .233-.189.422-.422.422h-1.406c-.233 0-.422-.189-.422-.422V4.672c0-.233.189-.422.422-.422h1.406c.233 0 .422.189.422.422v1.406z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "7ifjh6ayab",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#74bztgnbva"
})), React.createElement("g", {
  fill: "#A0A6B8",
  mask: "url(#7ifjh6ayab)"
}, React.createElement("path", {
  d: "M0 0H22V22H0z"
})));

var SvgIconBuilding = function SvgIconBuilding(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconBuilding, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-building.874148aa.svg";
export { ForwardRef as ReactComponent };